import { Images } from '@/assets/images';
import { DownloadPersonalInfoButton } from '@/components';
import { EXCEL_ACCEPT, PageTypeEnum } from '@/constant';
import { cn, truncateFileName } from '@/utils';
import { memo } from 'react';

import { includes } from 'ramda';

import Button from '../button';
import Modal from '../modal';
import { useLogic } from './logic';
import { TUploadExcelProps } from './type';

const UploadExcelButton = (props: TUploadExcelProps) => {
	const {
		labelButton = '등록(엑셀)',
		triggerClassName,
		hiddenButton = false,
		buttonType = 'button',
		pageType,
		...rest
	} = props;

	const {
		screenData,
		openModal,
		onToggle,
		inputRef,
		onChangeFile,
		fileName,
		handleClickButtonUpload,
		handleUploadFile,
		handleDeleteFile,
		handleDownloadTemplate,
		hasFailedList,
		handleDownloadFailedData,
		handleDownloadCurrentData,
		loading,
		getUploadExcelResult,
		disabledUploadExcel,
		showErrorFileResult,
	} = useLogic(props);

	return (
		<div>
			{!hiddenButton &&
				(buttonType === 'button' ? (
					<Button
						type="primary"
						ghost
						onClick={onToggle}
						className={cn(triggerClassName)}
						disabled={disabledUploadExcel}
						isMainBtn
					>
						{labelButton}
					</Button>
				) : (
					<div
						onClick={onToggle}
						className={cn(
							'min-w-20',
							triggerClassName,
							disabledUploadExcel &&
								'pointer-events-none !cursor-not-allowed opacity-50'
						)}
					>
						{labelButton}
					</div>
				))}

			<Modal
				open={openModal}
				onCancel={onToggle}
				title={screenData?.title}
				labelButton="저장"
				onClickButton={handleUploadFile}
				width={700}
				loading={loading}
				{...rest}
			>
				<div className="text-font2 font-normal text-[15px]">
					<p className="font-medium mb-5 text-sm leading-[26px] whitespace-pre-line">
						{screenData?.desc1}
					</p>

					<ul className="list-disc pl-6 mb-[5px] text-[13px]">
						<li className="mb-1">
							<p>
								양식에 맞춰 작성하여 업로드 해주세요.
								<span
									className="text-blue2 cursor-pointer underline underline-offset-2 ml-1 font-medium"
									onClick={handleDownloadTemplate}
								>
									{`엑셀 양식 다운로드 >`}
								</span>
							</p>
						</li>
						{!includes(pageType, [
							PageTypeEnum.ASSIGNMENT,
							PageTypeEnum.PUBLIC_ASSIGNMENT,
						]) && (
							<li>
								<div>
									{screenData?.desc2}
									<span className="font-semibold">{screenData?.desc3}</span>
									<div className="flex items-center">
										<p>{screenData?.desc4}</p>
										<DownloadPersonalInfoButton
											asChild
											onDownload={handleDownloadCurrentData}
										>
											<span className="text-blue2 cursor-pointer underline underline-offset-2 ml-1 font-medium">
												{screenData?.templateName + ' >'}
											</span>
										</DownloadPersonalInfoButton>
									</div>
								</div>
							</li>
						)}
					</ul>

					<div className="flex w-full gap-2 mb-5">
						<input
							type="file"
							className="hidden"
							name="upload"
							id="upload"
							accept={EXCEL_ACCEPT}
							onChange={onChangeFile}
							ref={inputRef}
							onClick={(e: any) => {
								e.target.value = null;
							}}
						/>
						<div className="h-[30px] w-full border">
							{fileName && (
								<div className="flex items-center justify-between h-full px-3">
									<p className="text-font2">{truncateFileName(fileName, 38)}</p>

									<div className="cursor-pointer" onClick={handleDeleteFile}>
										<img src={Images.iconCloseMini} />
									</div>
								</div>
							)}
						</div>
						<Button secondary onClick={handleClickButtonUpload}>
							업로드
						</Button>
					</div>

					{hasFailedList && showErrorFileResult && (
						<p className="text-font4 text-[13px]">
							등록 결과: {getUploadExcelResult.successCount}개 성공,{' '}
							<span className="text-red8">
								{getUploadExcelResult.failCount}개 실패
							</span>
							<span
								className="text-blue2 cursor-pointer underline underline-offset-2 ml-1 font-medium"
								onClick={handleDownloadFailedData}
							>
								{'등록되지 않은 정보 다운로드 >'}
							</span>
						</p>
					)}
				</div>
			</Modal>
		</div>
	);
};

export default memo(UploadExcelButton);
